import React, { useState, useEffect } from 'react';
import { Divider, Form, Input, message, Tooltip } from 'antd';


import './receiver-list.less';

import { customMessages } from 'utils';
import * as contactService from 'services/contact.service';
import { useSelector } from 'react-redux';
import DownChevronIcon from 'assests/icons/down-chevron.icon';
import DeleteIcon from 'assests/icons/delete.icon';
import classNames from 'classnames';
import SearchIcon from '../../assests/icons/search.icon';

import NewContact from 'assests/icons/new-contact.icon';
import { useDebouncedCallback } from 'use-debounce/lib';
import { InfoBox } from 'components';
const ReceiverList = (props) => {
  
  const auth = useSelector((state) => state.auth);
  const [contacts, setContacts] = useState([]);
  const [selectedContacts, setSelectedContacts] = useState([]);
  
  const [itemChange, setItemChange] = useState(0);

  const onSelectItem = (e) => {
    for( var i = 0; i < selectedContacts.length; i++){ 
      if ( selectedContacts[i].id === e.id) { 
          return;
      }
    }
    
    let newList = selectedContacts;
    newList.push(e);
    //console.log(newList);
    let a = itemChange;
    setItemChange(++a);
    setSelectedContacts(newList);
    props.onChange(newList.map(({ id }) => id));
  };

  const onRemoveList = (item) => {
    let newList = selectedContacts;
    for( var i = 0; i < newList.length; i++){ 
      if ( newList[i].id === item.id) { 
          newList.splice(i, 1); 
          break;
      }
    }
    
    let a = itemChange;
    setItemChange(++a);
    setSelectedContacts(newList);
    props.onChange(newList.map(({ id }) => id));
  };

  const onClear = () => {
    setSelectedContacts([]);
    props.onChange([]);
  };

  // const onChange = (value) => {
  //   const inputValue = value.toUpperCase();

  //   const filteredArray = props.list.filter((item, index) => {
  //     return (
  //       item.name.toUpperCase().indexOf(inputValue) > -1 ||
  //       item.number.indexOf(inputValue) > -1
  //     );
  //   });
  //   setArrayList(filteredArray);
  // };

  function fetchContacts(name) {
    
    if (name.length>2)
    {
      contactService.getAllContacts(auth.user.userId,name)
        .then((result) => {
          setContacts(result.body.contacts.content);
        }).catch((response) => {
          message.error(customMessages.getMessage(response.responseCode));
        });
    }
    else{
      setContacts([]);
    }
  }

   
  const delayedOnValuesChange = useDebouncedCallback(
    // function
    (e) => {
      fetchContacts(e);
    },
    // delay in ms
    500
  );


  useEffect(() => {
    fetchContacts("");
  }, []);


  return (
     <div className="receiver-list">
       <Divider></Divider>
<h3 >Rehberinizdeki Numaralar</h3>
<InfoBox
                          type="warning"
                          content={
                            <p>
                             Rehberinizde bulunan numaralardan tekli seçim yapmak için aşağıdaki alandan arama yapabilirsiniz.
                            </p>
                          }
                        />
                        <br></br>
      <div className="receiver-list__body">
       <div style={{display:'none'}}>{selectedContacts.length}</div>
          <>
            <div>
              {/* <div
                className="new-contact"
                onClick={() => {
                  setModalNewUser(true);
                }}
              >
                 <NewContact /> 
              </div> */}
              <div style={{ width: '100%' }}>
                <Tooltip title="En az 3 karakter giriniz.">
                <Input
                  placeholder="Rehberinizden İsim veya No Ara…"
                  autoComplete="off"
                  style={{ width: '100%' }}
                  onChange={(e) => {delayedOnValuesChange(e.target.value)}}
                /></Tooltip>
              </div>
            </div>
            <div>
                  <div className="message-list--v2">
                    {contacts.map((item, index) => (
                      <div
                      className={classNames('message-list__item', {'selected':  selectedContacts.map(({ id }) => id).includes(item.id)})}
                        key={'guide-item' + index}
                        onClick={(e) => { 
                          if (selectedContacts.map(({ id }) => id).includes(item.id)) {
                            onRemoveList(item, index);
                          }else
                          { 
                            onSelectItem(item, index);
                          }
                        }}

                      >
                        <p>{item.msisdn}</p>
                        <span>{item.name}</span>
                        <div className="select  only-icon"  onClick={(e) => (onSelectItem(item, index))}>
            <DownChevronIcon />
          </div>
          <div className="delete only-icon" onClick={(e) => (onRemoveList(item, index))} >
            
            <DeleteIcon />
          </div>
                      </div>
                    ))}
                  </div>
                  {(selectedContacts.length>0) &&
                  <div><br></br><h3 >Eklenen Numaralar</h3>
                    
                   <div className="message-list--v2">
                   {selectedContacts.map((item, index) => (
                      <div
                      className='message-list__item selected'
                        key={'guide-item' + index} onClick={(e) => (onRemoveList(item, index))}
                      >
                        <p>{item.msisdn}</p>
                        <span>{item.name}</span>
                     
          <div className="delete only-icon" onClick={(e) => (onRemoveList(item, index))} >
            
            <DeleteIcon />
          </div>
                      </div>
                    ))}
                    </div>

                   <button className="remove-list" onClick={(e) => (onClear())}>Eklenen Numaraları Çıkar</button> 
                   </div>
                  }

            </div>
          </>
        
      </div></div>  
  );
};

export default ReceiverList;
